export const servicesLarge = [
  {
    title: "<span>Program</span> Management",
    id: "program-management",
    description: (
      <>
        <p>
          SoulScale offers a comprehensive program management consulting
          services to help organisations excel in their projects. With extensive
          knowledge and experience, we guide you through planning, execution,
          and monitoring. We design strategies from small-scale initiatives to
          large projects that cater to your unique needs. Our user-friendly
          platform provides access to resources like case studies, industry
          insights, and best practices. Whether you need help with program
          design, risk management, stakeholder engagement, or performance
          evaluation, our dedicated team is here to empower your success.
          Streamline your program management processes and achieve exceptional
          results with our consultancy services. Some bullets:
        </p>
      </>
    ),
    image: "/images/program.png",
    points: [
      "MEL",
      "Risk Assessment and mitigation",
      "Case Study Framework",
      "Knowledge Management",
      "End-to-end, last-mile delivery programmatic support",
    ],
  },
  {
    title: "<span>Impact</span> Assessment",
    id: "impact-assessment",
    description: (
      <>
        <p>
          Our impact assessment services are specifically designed for measuring
          and understanding the effects of an organisation’s initiatives. We
          offer comprehensive assessments that focus on the social,
          environmental, and economic impacts of your projects. Our experts
          employ robust methodologies to gather data, analyse results, and
          provide actionable insights. Our services enable you to demonstrate
          the value and outcomes of your efforts, from evaluating the
          effectiveness of community development programs to measuring
          sustainability practices. Some bullets:
        </p>
      </>
    ),
    image: "/images/ai.jpeg",
    points: ["Evaluation", "Surveys", "PI"],
  },
  {
    title: "Research",
    id: "research",
    description: (
      <>
        <p>
          Our research services comprise a diverse range of areas, including
          internal migration, climate change, sustainability, and sexual
          violence against women and children. With a team of efficient,
          experienced and well-trained researchers and academics, we deliver
          comprehensive studies utilising industry-standard methodologies. Some
          bullets:
        </p>
      </>
    ),
    image: "/images/research.jpg",
    points: ["Survey and tools", "Field assessment", "Sampling Review", "Etc"],
  },
  {
    title: "Documentation and Registration",
    id: "documentation-and-registration",
    description: (
      <>
        <p>
          SoulScale has been working with an array of clients from diverse
          backgrounds and has successfully aided them in vital documentation
          processes and compliances. Some of the documentation services we offer
          are:
        </p>
      </>
    ),
    image: "/images/documentation.jpg",
    points: [
      "Legal Compliance Review",
      "Retainership Services",
      "12A and 80G Registration",
      "FCRA Registration/ Prior Permission/ Renewal",
      "FCRA Return",
    ],
  },
  {
    title: "<span>Monitoring</span> and Evaluation",
    id: "monitoring-and-evaluation",
    description: (
      <>
        <p>
          Monitoring and Evaluation services from SoulScale offer a holistic and
          comprehensive approach to assessing and tracking project progress,
          ensuring outcomes align with objectives. We have prior experience and
          up-to-date expertise in data collection, analysis, and performance
          measurement, owing to which we provide valuable insights for
          evidence-based decision-making. We employ rigorous methodologies to
          monitor project activities, evaluate results, and identify areas for
          improvement. In a bid to attain impactful results, our services assist
          in an array of vital and end-to-end mechanisms ranging from
          establishing robust monitoring frameworks to conducting comprehensive
          evaluations. Some bullets:
        </p>
      </>
    ),
    image: "/images/monitoring.png",
    points: [],
  },
  {
    title: "<span>CSR</span> Services",
    id: "csr-services",
    description: (
      <>
        <p>
          SoulScale offers CSR services to assist organisations in developing
          and implementing impactful Corporate Social Responsibility
          initiatives. We deliver comprehensive support in aligning CSR
          strategies with business goals, identifying key focus areas, and
          designing sustainable community engagement programs. Some bullets:
        </p>
      </>
    ),
    image: "/images/CSR-Baseline-Assessment.webp",
    points: [
      "Developing Proposal Screening Tools",
      "Due Diligence/ Pre-Grant Assessment",
      "Financial Review",
      "Monitoring and Evaluation",
      "Capacity Building and Training",
    ],
  },
  {
    title: "<span>Financial Management</span> and Legal Compliance Services",
    id: "cfo-services",
    description: (
      <>
        <p>
          In order to promote organisational success, our CFO services offer
          strategic financial leadership and expertise. With the help of our
          knowledgeable team of financial experts, we provide complete solutions
          catered to your unique needs. Our CFO services guarantee sound
          financial decision-making across budgeting, risk management, and
          financial planning and analysis. To improve profitability, operations
          efficiency, and cash flow, we offer analysis and suggestions. You can
          overcome difficult financial obstacles, develop sound strategic plans,
          and achieve long-term growth with our assistance. Some bullets:
        </p>
      </>
    ),
    image: "/images/cfo.jpg",
    points: [
      "Fund Utilization Review",
      "Compliance Review",
      "Prefunding Assessment",
      "Internal Audit",
    ],
  },
  {
    title: "<span>HR and </span> Talent Advisory Services",
    id: "hr-and-talent-advisory",
    description: (
      <>
        <p>
          Our HR and Talent Advisory services offer thorough assistance to
          enhance your company&apos;s human resources policies. We provide
          experience in hiring talent, motivating employees, managing
          performance, and fostering organisational growth. Our skilled team
          supports your efforts to draw in, nurture, and keep top talent while
          ensuring alignment with your corporate goals. Our services enable your
          business to develop a strong workforce and promote a positive
          workplace culture, from developing practical HR policies to putting in
          place performance evaluation systems.
        </p>
      </>
    ),
    image: "/images/hr.jpeg",
    points: [],
  },
  {
    title: "<span>Climate</span> Resilience & Innovation",
    id: "climate-resilience-and-innovation",
    description: (
      <>
        <p>
          SoulScale provides technical and implementation support for
          worker-centric climate adaptation — including heat resilience, cooling
          centres, hydration systems, climate-risk insurance, resilient housing,
          and climate-responsive social protection. We help partners design,
          pilot and scale practical, evidence-based solutions for informal and
          migrant workers.
        </p>
      </>
    ),
    image: "/images/climate-change.webp",
    points: [],
  },
];
